import { fechaLocal, fechaHoy } from "./internacional";

export const generarNombreArchivo = (tipo, fecha, nombreCliente) => {
  const fechaLimpia = fechaLocal(fecha) || fechaHoy();

  const nombreLimpio = (nombreCliente || "Cliente").replace(/\s+/g, "_");
  const prefijos = {
    cotizacion: "Cot_",
    orden: "Ord_",
    remision: "Rem_",
    recepcion: "Rcp_"
  };
  const prefijo = prefijos[tipo] || "Doc_";
  return `${prefijo}${fechaLimpia}_${nombreLimpio}.pdf`;
};